import React from 'react';
import { useDispatch } from "react-redux";
import Langs from "../../app/lang/langs";
import { hidePopup, onPopupConfirm } from "../../containers/common/commonSlice";
import ConfirmDialog from "./ConfirmDialog";

/**
 * The app-wide popup driven by commonSlice's showPopup, drawn by the shared ConfirmDialog.
 * A `CONFIRM_*` title asks a question (a `CONFIRM_DELETE_*` one as a delete); anything else
 * is a notice with a single OK.
 */
export function PopupModalCentered(props) {

    const dispatch = useDispatch();
    const isQuestion = !!(props.title && props.title.includes("CONFIRM_"));
    const isDelete = isQuestion && props.title.includes("DELETE");

    return <ConfirmDialog
        open={!!props.show && !!props.title}
        title={<Langs str={props.title} />}
        message={<Langs str={props.message} />}
        danger={isDelete}
        hideCancel={!isQuestion}
        confirmLabel={isQuestion ? (isDelete ? undefined : <Langs str="YES" />) : <Langs str="OK" />}
        cancelLabel={isQuestion && !isDelete ? <Langs str="NO" /> : undefined}
        onConfirm={() => isQuestion ? dispatch(onPopupConfirm(props.title)) : dispatch(hidePopup())}
        onCancel={() => dispatch(hidePopup())}
    />
}
